export const modalConfig = {
    onShow: modal => modal.dispatchEvent(new Event('show')),
    onClose: modal => modal.dispatchEvent(new Event('close')),
    openClass: 'is-opened',
    disableScroll: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
};
